import { format } from "date-fns";

/**
 * Format date and time to backend format
 */
export const formatDateTime = (date: Date, time: string): string => {
  const [hours, minutes] = time.split(':');
  const dateTime = new Date(date);
  dateTime.setHours(parseInt(hours), parseInt(minutes), 0, 0);
  return format(dateTime, "yyyy-MM-dd HH:mm:ss");
};

/** Translation keys in the `export` namespace, resolved at the render boundary. */
export type DateRangeErrorKey =
  | "validation.datesRequired"
  | "validation.startAfterEnd";

/**
 * Validate date range. Returns a translation key rather than a message: this is
 * a module-level util with no access to `t`.
 */
export const validateDateRange = (
  startDate: Date | undefined,
  endDate: Date | undefined,
): DateRangeErrorKey | null => {
  if (!startDate || !endDate) {
    return "validation.datesRequired";
  }

  if (startDate > endDate) {
    return "validation.startAfterEnd";
  }

  return null;
};

/**
 * Get default dates (today)
 */
export const getDefaultDates = () => {
  const today = new Date();
  return {
    startDate: today,
    endDate: today,
  };
};
